// API tabanı. Lokalde sahibimtatilde-server (5003), production'da .env ile verilir.
export const API_BASE =
  process.env.REACT_APP_API_URL || "https://api.sahibimtatilde.com";

// Tüm istekler cookie (admin oturumu) taşıyabilsin diye credentials: "include".
export async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* gövde yok */
  }
  if (!res.ok) {
    const err = new Error(data?.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}
